export const PrescriptionRejectedIllustration = () => (
  <svg
    aria-hidden
    className="text-primary h-[120px] w-[200px]"
    data-testid="report-ready-illustration-prescription-rejected"
    fill="none"
    viewBox="0 0 200 120"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_5046_163550)">
      <rect fill="white" height="103.278" rx="8" width="76.2851" x="56" y="8" />
    </g>
    <path
      d="M64.8034 93.642C64.999 90.5124 66.2117 84.8399 69.4979 87.1871C73.6055 90.1212 73.0187 97.1625 70.6715 93.642C68.7937 90.8257 64.8034 88.5568 63.043 87.7743L78.8868 90.7084"
      stroke="var(--theme-primary-light, #e8f4fe)"
      strokeLinecap="round"
    />
    <path
      d="M101.066 27.9604C101.45 27.5833 101.45 26.9643 101.066 26.5872C100.692 26.2203 100.093 26.2199 99.7192 26.5863L96.2241 30.0078L93.3104 27.1586C95.1015 26.4225 96.4027 24.6749 96.4027 22.692C96.4027 20.1031 94.183 18 91.4582 18H86.5137V31.3943C86.5137 31.9311 86.9489 32.3663 87.4857 32.3663C88.0226 32.3663 88.4578 31.9311 88.4578 31.3943V27.5291H90.9428L94.8515 31.3548L91.3886 34.7447C91.0038 35.1214 91.0034 35.7407 91.3878 36.1179C91.7613 36.4845 92.3596 36.4849 92.7336 36.1187L96.2292 32.6968L99.7247 36.1187C100.099 36.4849 100.697 36.4845 101.071 36.1179C101.455 35.7407 101.455 35.1214 101.07 34.7447L97.6069 31.3548L101.066 27.9604ZM88.4578 25.6163V19.9028H91.4582C93.1114 19.9028 94.4586 21.1547 94.4586 22.687C94.4586 24.2743 93.0859 25.6163 91.4582 25.6163H88.4578Z"
      fill="currentColor"
    />
    <path
      d="M62.5 57.1699C62.5 56.2886 63.2144 55.5742 64.0957 55.5742H123.904C124.786 55.5742 125.5 56.2886 125.5 57.1699C125.5 58.0512 124.786 58.7656 123.904 58.7656H64.0957C63.2144 58.7656 62.5 58.0512 62.5 57.1699Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62.5 62.4844C62.5 61.6031 63.2144 60.8887 64.0957 60.8887H123.904C124.786 60.8887 125.5 61.6031 125.5 62.4844C125.5 63.3657 124.786 64.0801 123.904 64.0801H64.0957C63.2144 64.0801 62.5 63.3657 62.5 62.4844Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62.5 67.8047C62.5 66.9234 63.2144 66.209 64.0957 66.209H123.904C124.786 66.209 125.5 66.9234 125.5 67.8047C125.5 68.686 124.786 69.4004 123.904 69.4004H64.0957C63.2144 69.4004 62.5 68.686 62.5 67.8047Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62.5 73.123C62.5 72.2418 63.2144 71.5273 64.0957 71.5273H123.904C124.786 71.5273 125.5 72.2418 125.5 73.123C125.5 74.0043 124.786 74.7188 123.904 74.7188H64.0957C63.2144 74.7188 62.5 74.0043 62.5 73.123Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62.5 78.3145C62.5 77.4332 63.2144 76.7188 64.0957 76.7188H87.4993C88.3806 76.7188 89.095 77.4332 89.095 78.3145C89.095 79.1957 88.3806 79.9102 87.4993 79.9102H64.0957C63.2144 79.9102 62.5 79.1957 62.5 78.3145Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <path
      d="M62.5 48C62.5 46.8954 63.3954 46 64.5 46H82.8398C83.9444 46 84.8398 46.8954 84.8398 48V49.319C84.8398 50.4236 83.9444 51.319 82.8398 51.319H64.5C63.3954 51.319 62.5 50.4236 62.5 49.319V48Z"
      fill="var(--theme-primary-light, #e8f4fe)"
    />
    <g filter="url(#filter1_d_5046_163550)">
      <g clipPath="url(#clip0_5046_163550)">
        <rect fill="white" height="24" rx="12" width="24" x="120.5" y="48" />
        <path
          d="M132.5 49C138.575 49 143.5 53.9249 143.5 60C143.5 66.0751 138.575 71 132.5 71C126.425 71 121.5 66.0751 121.5 60C121.5 53.9249 126.425 49 132.5 49Z"
          stroke="var(--theme-warning, #ff9800)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M124.289 51.7891L140.71 68.2101"
          stroke="var(--theme-warning, #ff9800)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </g>
    <defs>
      <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="115.278" id="filter0_dd_5046_163550" width="88.2852" x="50" y="4">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.184314 0 0 0 0 0.235294 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_5046_163550" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.184314 0 0 0 0 0.235294 0 0 0 0.08 0" />
        <feBlend in2="effect1_dropShadow_5046_163550" mode="normal" result="effect2_dropShadow_5046_163550" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow_5046_163550" mode="normal" result="shape" />
      </filter>
      <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="28" id="filter1_d_5046_163550" width="28" x="118.5" y="47">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.184314 0 0 0 0 0.235294 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_5046_163550" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_5046_163550" mode="normal" result="shape" />
      </filter>
      <clipPath id="clip0_5046_163550">
        <rect fill="white" height="24" rx="12" width="24" x="120.5" y="48" />
      </clipPath>
    </defs>
  </svg>
)
